import "./style.scss";
import { useState } from "react";
import {
  universityProgramsTabs,
  universityProgramsBachelor,
  universityProgramsMasters,
  universityProgramsDoctorate,
  universityProgramsCourses,
} from "@/src/constants/university-programs";
import Tabs from "@/src/components/Tabs/Tabs";
import UniversityProgramsContent from "./UniversityProgramsContentDesk/UniversityProgramsContentDesk";

const UniversityProgramsDesk = () => {
  const [currentTab, setCurrentTab] = useState<string>("bachelor");
  const [universityCardName, setUniversityCardName] = useState(universityProgramsBachelor[0].name);

  const handleTabChange = (tabId: string) => {
    setCurrentTab(tabId);
    switch (tabId) {
      case "bachelor":
        setUniversityCardName(universityProgramsBachelor[0].name);
        break;
      case "masters":
        setUniversityCardName(universityProgramsMasters[0].name);
        break;
      case "doctorate":
        setUniversityCardName(universityProgramsDoctorate[0].name);
        break;
      case "courses":
        setUniversityCardName(universityProgramsCourses[0].name);
        break;
    }
  };

  return (
    <div className="university-programs container">
      <div className="university-programs-header">
        <Tabs title="University Programs" tabs={universityProgramsTabs} currentTab={currentTab} setCurrentTab={handleTabChange} />
      </div>
      <div className="university-programs-body">
        <UniversityProgramsContent
          content={
            currentTab === "bachelor"
              ? universityProgramsBachelor
              : currentTab === "masters"
              ? universityProgramsMasters
              : currentTab === "doctorate"
              ? universityProgramsDoctorate
              : universityProgramsCourses
          }
          universityCardName={universityCardName}
          setUniversityCardName={setUniversityCardName}
        />
      </div>
    </div>
  );
};

export default UniversityProgramsDesk;
